import React from 'react'
import {Card, Item, Button, CardActions, Grid, Container} from '@mui/material'

const Info = () => {
    return ( <div className='text-center colorbase' style={{paddingTop: 100}}>
        <h3 className='mb-3'>รวมสื่อประชาสัมพันธ์</h3>
        <Container>
            <Grid container className='color-text' spacing={2}>
                <Grid item md={4}>
                        <Card className='text-center'>
                            <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset9.webp' className='p-1 bg-body' width='100%' />
                            <CardActions className='justify-content-center bg-header'>
                                <Button className='text-light w-100 h4' href='https://cfl.gpf.or.th/Files/Viewer/?fileName=75697b24-2c45-4829-9d94-b8ad25841851/Introduction_My_gpf_%20my_gpf_twins.pdf' target='_blank'>
                                    ดาวน์โหลด คลิก!
                                </Button>
                            </CardActions>
                        </Card>
                </Grid>
                <Grid item md={4}>
                    <Card className='text-center'>
                        <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset10.webp' className='p-1 bg-body' style={{objectFit: 'contain',width :'500px',height :'373px', objectPosition: '100%, 20%'}}  width='100%' />
                            <CardActions className='justify-content-center bg-header'>
                                <Button className='text-light w-100 h4' href='https://cfl.gpf.or.th/Files/Viewer/?fileName=dda0af95-4228-4a34-95c5-64c8bd4441c1/GPF%20JOURNAL%20december%202022.pdf' target='_blank'>
                                    ดาวน์โหลด คลิก!
                                </Button>
                            </CardActions>
                        </Card>
                </Grid>
                <Grid item md={4}>
                    <Card className='text-center'>
                        <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset11.webp' className='p-1 bg-body'  width='100%' />
                            <CardActions className='justify-content-center bg-header'>
                                <Button className='text-light w-100 h4' href='https://cfl.gpf.or.th/Files/Viewer/?fileName=9c6b8aca-6bba-4c8d-9a5c-cec8d033ae7c/My_Twin1_and_My_Twin2.pdf' target='_blank'>
                                    ดาวน์โหลด คลิก!
                                </Button>
                            </CardActions>
                        </Card>
                </Grid>
          </Grid>
      </Container>
    </div> );
}
 
export default Info;